// getTokenPrices.ts
export async function getTokenPrices(): Promise<Record<string, number>> {
    const defaultPrices: Record<string, number> = {
      tether: 1,
      "usd-coin": 0.999991,
      "true-usd": 0.9999,
      dai: 0.999994,
      "wrapped-bitcoin": 103889,
      ethereum: 2545.5,
      chainlink: 17.34,
    };
  
    try {
      const res = await fetch(
        'https://api.coingecko.com/api/v3/simple/price?ids=tether,usd-coin,true-usd,dai,wrapped-bitcoin,ethereum,chainlink&vs_currencies=usd'
      );
      const json = await res.json();
  
      // 合并默认值与接口结果（优先接口数据）
      for (const key in defaultPrices) {
        if (json[key]?.usd) {
          defaultPrices[key] = json[key].usd;
        }
      }
  
      return defaultPrices;
    } catch (error) {
      //console.warn("⚠️ 获取代币价格失败，使用默认值：", error);
      return defaultPrices;
    }
  }